<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication1a"><a id="page_ii">For my wife, Stephanie, who is my beloved and my best friend, and has always got my back.</a></p><a id="page_ii">
<p class="dedication1">For my children, Eian and Michaela, may they never be afraid to be exactly who they are.</p>
<p class="dedication1">Most of all for my mother, Erma, who gave to me her love for the written word and taught me how to dream.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedication.vue?1d167aca